import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import AccountView from './AccountView';

const AccountPage: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <AccountView
      fullName={user?.userName?.trim() || ''}
      email={user?.userEmail?.trim() || ''}
      phone={user?.userPhone?.trim() || ''}
      loginType={user?.loginType || ''}
      playerId={user?.playerId || ''}
      onSignOut={() => {
        logout();
        navigate('/', { replace: true });
      }}
    />
  );
};

export default AccountPage;
